/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NoSpenderListProjection } from '../models/NoSpenderListProjection';
import type { NoSpendersListsForm } from '../models/NoSpendersListsForm';
import type { PageFanResponseProjection } from '../models/PageFanResponseProjection';
import type { PageNoSpenderListProjection } from '../models/PageNoSpenderListProjection';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DashboardNoSpenderListRestEndpointService {
    /**
     * @returns NoSpenderListProjection OK
     * @throws ApiError
     */
    public static dashboardGetNoSpenderList({
        creatorId,
        listId,
    }: {
        creatorId: number,
        listId: number,
    }): CancelablePromise<NoSpenderListProjection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/list-feature/no-spender-list/creator/{creatorId}/list/{listId}',
            path: {
                'creatorId': creatorId,
                'listId': listId,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static dashboardUpdateNoSpenderList({
        creatorId,
        listId,
        requestBody,
    }: {
        creatorId: number,
        listId: number,
        requestBody: NoSpendersListsForm,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/list-feature/no-spender-list/creator/{creatorId}/list/{listId}',
            path: {
                'creatorId': creatorId,
                'listId': listId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static dashboardDeleteNoSpenderList({
        creatorId,
        listId,
    }: {
        creatorId: number,
        listId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/list-feature/no-spender-list/creator/{creatorId}/list/{listId}',
            path: {
                'creatorId': creatorId,
                'listId': listId,
            },
        });
    }
    /**
     * @returns PageNoSpenderListProjection OK
     * @throws ApiError
     */
    public static dashboardGetNoSpenderLists({
        creatorId,
        name,
        page,
        size = 20,
    }: {
        creatorId: number,
        name?: string,
        page?: number,
        size?: number,
    }): CancelablePromise<PageNoSpenderListProjection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/list-feature/no-spender-list/creator/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'name': name,
                'page': page,
                'size': size,
            },
        });
    }
    /**
     * @returns NoSpenderListProjection OK
     * @throws ApiError
     */
    public static dashboardCreateNoSpenderList({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: NoSpendersListsForm,
    }): CancelablePromise<NoSpenderListProjection> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/list-feature/no-spender-list/creator/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PageFanResponseProjection OK
     * @throws ApiError
     */
    public static dashboardGetNoSpenderListFans({
        creatorId,
        listId,
        fanName,
        page,
        size = 20,
    }: {
        creatorId: number,
        listId: number,
        fanName?: string,
        page?: number,
        size?: number,
    }): CancelablePromise<PageFanResponseProjection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/list-feature/no-spender-list/creator/{creatorId}/list/{listId}/fans',
            path: {
                'creatorId': creatorId,
                'listId': listId,
            },
            query: {
                'fanName': fanName,
                'page': page,
                'size': size,
            },
        });
    }
}
